import React from 'react';
import { Divider, Header, List } from 'semantic-ui-react';
import Emoji from '../../../Reusable/Emoji';

import './front-end.scss';

import data from './frontendData';

const FrontEnd = () => {
  
  return (
    
    <div id="frontEnd">
        <Divider horizontal>
          <Header className='custom-header' as='h4'>
          <Emoji emoji='male-artist' set='google' size={26} />
            Front End
          </Header>
        </Divider>
        <List divided relaxed>        
          {data.front.map((item) => (
            <List.Item key={item.id}>
              <List.Icon as='i' className={`${item.icon} colored`} size='large' verticalAlign='middle' />
              <List.Content>
                <List.Header as='h3'>{item.name}</List.Header>
                <List.Description>{item.desc}</List.Description>
              </List.Content>
            </List.Item>
          ))}
        </List>

        <Divider horizontal>
          <Header className='custom-header' as='h4'>
            <Emoji emoji='male-technologist' set='google' size={26} />
            Feature Librairies
          </Header>
        </Divider>        
        <List divided relaxed>
          {data.lib.map((item) => (
          <List.Item key={item.id}>
            <List.Icon name='github' size='large' verticalAlign='middle' />
            <List.Content>
              <List.Header as='a' href={item.link} target='_blank'>{item.name}</List.Header>
              <List.Description>{item.desc}</List.Description>
            </List.Content>
          </List.Item>
          ))}
        </List>
    </div>
    
  );  
  
};

FrontEnd.propTypes = {
};

export default FrontEnd;
